import React from 'react';
import $ from "jquery";
import Server from '../../../functions/server';
import Loading from '../../loading';
import Buttons from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Grid, Input, Popup } from 'semantic-ui-react';
import ReadCookie from '../../../functions/readcookies';

class OutBound extends React.Component {

  state = {
    data: [],
    openView: false,
    viewbound: [],
    load: false,
  }

  componentDidMount() {
    this.getOutBound();
  }

  componentDidUpdate(props) {
    if (props.selectedBranch != this.props.selectedBranch) {
      this.getOutBound();
    }
  }

  getOutBound() {
    let context = this;
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    context.setState({
      load: true,
      message: 'Getting OutBound!!!'
    });
    let branch = this.props.selectedBranch;
    let data1 = { 'branch' : branch, 'userId': userId };

    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'stocktransfer/getoutbound.php',
      success: function(data)
      {
        console.log(data);
        context.setState({
          load: false,
        });
        try {
          data = JSON.parse(data);
          console.log(data);
          for (var i = 0; i < data.length; i++) {
            let s = 1;
            data[i].sino = s + i;
          }
          context.setState({ data: data })
        } catch (e) {
          context.setState({
            load: false,
          });
        }
      },
      error: function(err)
      {
        console.log(err);
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  view(val) {
    let context = this;
    context.setState({ load: true, message: 'Getting Stock Out!!!', openView: true });
    $.ajax({
      type: 'POST',
      data: { 'value': val },
      url: Server() + 'stocktransfer/viewoutbound.php',
      success: function(data) {
        try {
          data = JSON.parse(data);
          for (var i = 0; i < data.length; i++) {
            let s = 1;
            data[i].sino = s + i;
          }
          context.setState ({ viewbound: data, load: false })
        } catch (e) {
          context.setState({ load: false });
        }
      },
      error: function(err) {
        context.setState({ load: false });
        alert('Try again!!!!')
      }
    });
  }

  handleClose = () => { this.setState({ openView: false  }); };

  search() {
    let search = document.getElementById('search').value;
    this.setState({ search: search });
  }

  handleChange = name => event => { this.setState({ [name]: event.target.value }); };

  convertTOUpperCase(value) {
    try {
      value = value.toUpperCase();
    } catch (e) {
      value = '';
    }
    return value;
  }

  downloadPdf(id) {
    let open = Server() + "pdf/stocktransferpdfcreation/transfer.php?id="+id;
    window.open(open);
  }

  convertToNumber(value) {
    try {
      value = Number(value).toFixed(2);
    } catch (e) {
      value = 0;
    }
    return value;
  }

  dateFormat(value) {
    let date = value.split(' ')[0];
    let time = value.split(' ')[1];
    return date.split('-')[2]+'-'+date.split('-')[1]+'-'+date.split('-')[0]+' '+time;
  }

  render() {
    let remarks = '';
    return (
      <div style={{display: this.props.stockoutview, padding: '0.5%'}}><br/>
        <Loading load={this.state.load} message={this.state.message} />
        <Grid>
          <Grid.Column mobile={16} tablet={16} computer={4}>
            <b>Search Branch</b><br/>
            <Input focus id="search" icon='search' onChange={this.search.bind(this)} fluid />
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={4}>
            <b>From Date</b><br/>
            <input type="date" id="from_date" style={{width: '100%', height: 35 }}
              onChange={this.handleChange('from_date')} />
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={4}>
            <b>To Date</b><br/>
            <input type="date" id="to_date" style={{width: '100%', height: 35 }}
              onChange={this.handleChange('to_date')} />
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={16}>
            { this.state.data ?
              (
                <table width='100%' id='table'>
                  <tr>
                  <th id='tableheader'><center>SiNo</center></th>
                  <th id='tableheader'><center>Voucher No</center></th>
                  <th id='tableheader'><center>To Branch</center></th>
                  <th id='tableheader'><center>Time</center></th>
                  <th id='tableheader'><center>By</center></th>
                  <th id='tableheader'><center>Stocks</center></th>
                  <th id='tableheader'><center>Amount</center></th>
                  <th id='tableheader'><center>Total Shortage</center></th>
                  <th style={{cursor: 'pointer'}} id='tableheader'>View</th>
                  </tr>
                  {this.state.data.map((z) => {
                    let from_date = this.state.from_date;
                    let to_date = this.state.to_date;
                    let value = this.convertToNumber(z.value);
                    let times = this.dateFormat(z.times);
                    let substring;
                    if (this.state.search) {
                      let search = this.convertTOUpperCase(this.state.search);
                      let word = this.convertTOUpperCase(z.to_branch);
                      try {
                        substring = word.includes(search);
                      } catch (e) {
                        substring = false;
                      }
                      if (substring == true) {
                        return (
                          <tbody>
                            <Popup content={<div>
                                <div>
                                  <b>Remarks: </b>{z.remarks}
                                </div><br/>
                                <div>
                                  <b>Refrence ID: </b>{z.reference}
                                </div><br/>
                              </div>} trigger={
                              <tr>
                                <td><center>{z.sino}</center></td>
                                <td style={{cursor: 'pointer', color: '#5EA2D7'}} onClick={this.downloadPdf.bind(this, z.id)}><u>{z.voucher_no}</u></td>
                                <td>{z.to_branch}</td>
                                <td><center>{times}</center></td>
                                <td>{z.employee}</td>
                                <td><center>{z.stocks}</center></td>
                                <td><center>{value}</center></td>
                                <td><center>{z.discrepancy}</center></td>
                                <td style={{cursor: 'pointer'}}>
                                <center onClick={this.view.bind(this, z.id)}>view</center>
                                </td>
                              </tr>
                            }/>
                          </tbody>

                        );
                      }
                    }
                    else if (from_date && to_date) {
                      from_date = from_date+" "+"00:00:00";
                      to_date = to_date+" "+"00:00:00";
                      if (from_date < z.times && to_date > z.times) {
                        return (
                          <tbody>
                              <Popup content={<div>
                                  <div>
                                    <b>Remarks: </b>{z.remarks}
                                  </div><br/>
                                  <div>
                                    <b>Refrence ID: </b>{z.reference}
                                  </div><br/>
                                </div>} trigger={
                              <tr>
                                <td><center>{z.sino}</center></td>
                                <td style={{cursor: 'pointer', color: '#5EA2D7'}} onClick={this.downloadPdf.bind(this, z.id)}><u>{z.voucher_no}</u></td>
                                <td>{z.to_branch}</td>
                                <td><center>{times}</center></td>
                                <td>{z.employee}</td>
                                <td><center>{z.stocks}</center></td>
                                <td><center>{value}</center></td>
                                <td style={{cursor: 'pointer'}}>
                                <center onClick={this.view.bind(this, z.id, 'view')}>view</center>
                                </td>
                                <td style={{cursor: 'pointer', display: this.props.stockinedit}}>
                                  <center onClick={this.view.bind(this, z.id, 'show')}>
                                    Shortage
                                  </center>
                                </td>
                              </tr>} />
                          </tbody>

                        );
                      }
                      else {
                      }
                    }
                    else {
                      return (
                        <tbody>
                            <Popup content={<div>
                                <div>
                                  <b>Remarks: </b>{z.remarks}
                                </div>
                                <div>
                                  <b>Refrence ID: </b>{z.reference}
                                </div>
                              </div>} trigger={
                            <tr>
                              <td><center>{z.sino}</center></td>
                              <td style={{cursor: 'pointer', color: '#5EA2D7'}} onClick={this.downloadPdf.bind(this, z.id)}><u>{z.voucher_no}</u></td>
                              <td>{z.to_branch}</td>
                              <td><center>{times}</center></td>
                              <td>{z.employee}</td>
                              <td><center>{z.stocks}</center></td>
                              <td><center>{value}</center></td>
                              <td style={{cursor: 'pointer'}}>
                              <center onClick={this.view.bind(this, z.id, 'view')}>view</center>
                              </td>
                              <td style={{cursor: 'pointer', display: this.props.stockinedit}}>
                                <center onClick={this.view.bind(this, z.id, 'show')}>
                                  Shortage
                                </center>
                              </td>
                            </tr>} />
                        </tbody>

                      );
                    }
                  }
                )}
              </table>
            ) :
            (<div></div>)
          }
          </Grid.Column>
        </Grid>
        <Dialog open={this.state.openView} onClose={this.handleClose}
          aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
          <DialogTitle id="alert-dialog-title" style={{width: 600}}>{"View Stock Out"}</DialogTitle>
          <DialogContent>
            <table width='100%' id='table'>
              <tr>
                <th><center>Sino</center></th>
                <th><center>Part No</center></th>
                <th><center>Brand Name</center></th>
                <th><center>Stock</center></th>
                <th><center>Shortage</center></th>
              </tr>
              {this.state.viewbound.map((z) => {
                remarks = z.remarks;
                return (
                  <tr>
                    <td><center>{z.sino}</center></td>
                    <td><center>{z.partno+'->'+z.name}</center></td>
                    <td><center>{z.brand_name}</center></td>
                    <td><center>{z.stock}</center></td>
                    <td><center>{z.discrepancy}</center></td>
                  </tr>
                );
              }
              )}
            </table>
            { remarks.length >= 1 ?
              (<div>{'Remarks : '+remarks}</div>):
              (<div></div>)
            }
          </DialogContent>
          <DialogActions>
            <Buttons onClick={this.handleClose.bind(this)} color="primary" autoFocus>
              Okey
            </Buttons>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default OutBound;
